<template #header>
  <div>
    <!-- Header -->
    <v-container fluid class="header-container" color="primary">
      <v-row>
        <!-- Logo -->
        <v-col cols="3" class="pa-0 pb-4 pl-2">
          <div class="image-container d-flex headerItemsContainer">
            <img
              :src="logoScreen"
              :class="headerItemsContainerClass"
              class="hover align-self-center pa-1"
              @click="goHome"
            />
          </div>
        </v-col>

        <!-- Barra de Busqueda -->
        <v-col
          cols="8"
          xs="8"
          sm="8"
          md="5"
          class="d-flex align-self-center pa-0"
        >
          <v-row>
            <v-col class="pt-6" cols="12">
              <searchBar :searchText="currentText.banner.searchBar"></searchBar>
            </v-col>
          </v-row>
        </v-col>

        <!-- Login, Sitio Web y Carro de Compras -->
        <v-col class="d-flex headerItemsContainer pa-1" cols="4">
          <v-container class="headerItemsContainer hidden-sm-and-down">
            <v-row class="headerItemsContainer pr-4 justify-center">
              <!-- Inicio de sesión -->
              <v-col
                class="pa-0 pl-4 d-flex align-center headerItemsContainer"
                cols="4"
                md="5"
                lg="4"
                xl="3"
              >
                <v-icon class="pa-2" dark>exit_to_app</v-icon>

                <v-container>
                  <!-- SignUp -->
                  <v-row v-if="!activeSession">
                    <label class="header-text" @click="login">
                      Inicia Sesión
                    </label>
                  </v-row>

                  <!-- SignIn -->
                  <v-row v-if="!activeSession">
                    <label @click="register" class="header-text">
                      Registrate
                    </label>
                  </v-row>

                  <!-- Sesión Activa -->
                  <v-row v-if="activeSession">
                    <!-- Menu Perfil Movil -->
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          text
                          v-on="on"
                          class="header-text"
                          @click="sessionOptions = !sessionOptions"
                        >
                          Hola
                          <br />
                          "{{ userName }}"
                          <v-icon>
                            {{
                              sessionOptions
                                ? "keyboard_arrow_up"
                                : "keyboard_arrow_down"
                            }}
                          </v-icon>
                        </v-btn>
                      </template>

                      <v-list color="secondary">
                        <!-- Perfil -->
                        <v-list-item class="list-element">
                          <v-list-item-content>
                            <a style="text-decoration: none" href="#/profile">
                              <v-list-item-title class="menu-text">
                                Perfil
                              </v-list-item-title>
                            </a>
                          </v-list-item-content>
                        </v-list-item>

                        <!-- Cerrar Sesión -->
                        <v-list-item class="list-element">
                          <v-list-item-content @click="closeSession">
                            <v-list-item-title class="menu-text">
                              Cerrar Sesión
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-row>
                </v-container>
              </v-col>

              <!-- Sitio Corporativo -->
              <v-col
                class="pa-0 d-flex align-center headerItemsContainer"
                cols="4"
                md="5"
                lg="4"
                xl="3"
              >
                <v-card id="corpSite" tile flat @click="goToRisoul()">
                  <v-img height="60px">
                    <v-app-bar
                      flat
                      class="headerItemsContainer pa-0"
                      color="primary"
                    >
                      <v-icon class="pa-2" color="white">business</v-icon>

                      <v-toolbar-title class="white--text menu-text">
                        Ir al sitio web
                      </v-toolbar-title>

                      <v-spacer></v-spacer>
                    </v-app-bar>
                  </v-img>
                </v-card>
              </v-col>

              <!-- Mi lista / Shopping Cart -->
              <v-col
                class="pa-0 d-flex align-center justify-center headerItemsContainer"
                cols="2"
              >
                <v-card tile flat href="#/list">
                  <v-img height="60px">
                    <v-app-bar
                      flat
                      class="headerItemsContainer pl-1"
                      color="primary"
                    >
                      <div class="pa-2 pl-2">
                        <v-badge left color="#FA6B17">
                          <template v-slot:badge>
                            {{ quantityShopping }}
                          </template>
                          <v-icon dark>shopping_cart</v-icon>
                        </v-badge>
                      </div>

                      <v-spacer></v-spacer>
                    </v-app-bar>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>

    <!-- ToolBar -->
    <v-toolbar
      class="navigation-bar second-toobar d-flex"
      color="secondary"
      height="40"
    >
      <v-toolbar-items class="hidden-sm-and-down">
        <v-spacer></v-spacer>

        <!-- Categorias -->
        <v-menu
          open-on-hover
          offset-y
          allow-overflow
          :close-on-click="false"
          :close-on-content-click="false"
        >
          <!-- Categories NavBar -->
          <template v-slot:activator="{ on }">
            <v-btn text small v-on="on" class="button-menu" href="/#/category">
              {{ currentText.menu.category }}
            </v-btn>
          </template>

          <!-- Categories List -->
          <v-card>
            <v-list color="secondary">
              <v-list-group
                v-for="item in parentCategory.noPDI"
                :key="item.id"
                no-action
                class="ListaAnidada"
              >
                <!-- Menus -->
                <template v-slot:activator>
                  <v-list-item-content class="pa-0" height="30">
                    <v-list-item-title
                      v-text="item.name"
                      class="menu-text-parent"
                    >
                    </v-list-item-title>
                  </v-list-item-content>
                </template>

                <!-- SubMenus -->
                <v-list-item
                  @click="goCategories(item, subItem, false)"
                  v-for="subItem in item.parent"
                  :key="subItem.id"
                >
                  <v-list-item-content class="pa-0 pl-4">
                    <v-list-item-title v-text="subItem.name" class="menu-text">
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list>
          </v-card>
        </v-menu>

        <!-- Menu Soluciones PDI -->
        <v-menu
          open-on-hover
          offset-y
          allow-overflow
          :close-on-click="false"
          :close-on-content-click="false"
        >
          <!-- Soluciones PDI NavBar -->
          <template v-slot:activator="{ on }">
            <v-btn text small v-on="on" href="/#/PDI" class="button-menu">
              {{ currentText.menu.solutions }}
            </v-btn>
          </template>

          <!-- Soluciones PDI List -->
          <v-card>
            <v-list color="secondary">
              <v-list-group
                v-for="item in parentCategory.PDI"
                :key="item.id"
                no-action
                class="ListaAnidada"
              >
                <!-- Menus -->
                <template v-slot:activator>
                  <v-list-item-content class="pa-0" height="30">
                    <v-list-item-title
                      v-text="item.name"
                      class="menu-text-parent"
                    >
                    </v-list-item-title>
                  </v-list-item-content>
                </template>

                <!-- SubMenus -->
                <v-list-item
                  @click="goCategories(item, subItem, true)"
                  v-for="subItem in item.parent"
                  :key="subItem.id"
                >
                  <v-list-item-content class="pa-0 pl-4">
                    <v-list-item-title v-text="subItem.name" class="menu-text">
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list>
          </v-card>
        </v-menu>

        <!-- Btn Marcas -->
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on }">
            <v-btn text small v-on="on" class="button-menu" href="/#/brands">
              {{ currentText.menu.brands }}
            </v-btn>
          </template>
        </v-menu>

        <!-- Menu Quick Orders -->
        <v-menu offset-y :close-on-click="true" :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-btn text small v-on="on" class="button-menu">
              {{ currentText.menu.orders }}
            </v-btn>
          </template>

          <toolbarQuickOrder
            :toolbar="true"
            :snackbar="snackbar"
            :updateShopingQuantity="updateShopingQuantity"
          >
          </toolbarQuickOrder>
        </v-menu>

        <!-- Btn Tracking -->
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on }">
            <v-btn text small v-on="on" class="button-menu" href="#/tracking">
              {{ currentText.menu.tracking }}
            </v-btn>
          </template>
        </v-menu>

        <!-- Btn Promociones -->
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on }">
            <v-btn text small v-on="on" href="#/promo" class="button-menu">
              {{ currentText.menu.promotions }}
            </v-btn>
          </template>
        </v-menu>

        <!-- Btn Sucursales -->
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              small
              v-on="on"
              class="button-menu"
              @click="goSucursales()"
            >
              {{ currentText.menu.branchOffice }}
            </v-btn>
          </template>
        </v-menu>

        <!-- Btn Tienda -->
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              class="button-menu-ventas onlineStore"
              @click="goStore()"
            >
              {{ currentText.menu.onlinesales }}
            </v-btn>
          </template>
        </v-menu>

        <v-spacer></v-spacer>

        <!--Lenguaje -->
        <div class="d-flex align-center">
          <v-select
            :items="languages"
            label="Language"
            hide-details
            single-line
            @change="setLanguage"
            dense
            flat
            solo
            item-value="name"
            item-text="name"
            v-model="selectedLanguage"
            class="lang-select"
          >
          </v-select>
        </div>
      </v-toolbar-items>

      <!-- ToolBar Movil -->
      <v-toolbar-items class="hidden-md-and-up">
        <!-- Menú Hamburguesa -->
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-app-bar-nav-icon v-on="on" style="color: white">
            </v-app-bar-nav-icon>
          </template>

          <!-- Option List -->
          <v-list dense>
            <v-list-item
              v-for="(item, index) in currentText.menu.navmenu"
              :key="index"
              class="hover"
              :href="item.href"
            >
              <v-list-item-title>
                {{ item.name }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- Menu Perfil Movil -->
        <v-menu v-if="activeSession" offset-y>
          <!-- Btn Perfil -->
          <template v-slot:activator="{ on }">
            <v-btn
              text
              v-on="on"
              class="button-menu-movil"
              @click="sessionOptions = !sessionOptions"
            >
              Hola "{{ userName }}"
              <v-icon>
                {{
                  sessionOptions ? "keyboard_arrow_up" : "keyboard_arrow_down"
                }}
              </v-icon>
            </v-btn>
          </template>

          <!-- Lst User Options -->
          <v-list color="secondary">
            <v-list-item class="list-element">
              <!-- Perfil -->
              <v-list-item-content>
                <a style="text-decoration: none" href="#/profile">
                  <v-list-item-title class="menu-text">
                    Perfil
                  </v-list-item-title>
                </a>
              </v-list-item-content>
            </v-list-item>

            <!-- Cerrar Sesión -->
            <v-list-item class="list-element">
              <v-list-item-content @click="closeSession">
                <v-list-item-title class="menu-text">
                  Cerrar Sesión
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- Btn Login Mobile -->
        <v-menu v-if="!activeSession" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              small
              v-on="on"
              class="button-menu-movil"
              @click="login"
            >
              Inicia Sesión
            </v-btn>
          </template>
        </v-menu>

        <!-- Btn Venta en línea -->
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              class="button-menu-movil onlineStoreMovil"
              @click="goStore()"
            >
              Venta en Línea
            </v-btn>
          </template>
        </v-menu>

        <v-spacer></v-spacer>

        <!-- Shopping Cart Icon -->
        <v-btn href="#/list" icon>
          <v-badge left color="#FA6B17">
            <template v-slot:badge>
              {{ quantityShopping }}
            </template>
            <v-icon> shopping_cart </v-icon>
          </v-badge>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
import _ from "underscore";
import { events } from "../../main";
import { coreText } from "../../utils/textTranslations";
import searchBar from "./child_searchBar.vue";
import toolbarQuickOrder from "./../quickorder/quickorderList_child.vue";

export default {
  name: "header-component",

  components: { searchBar, toolbarQuickOrder },

  data() {
    return {
      sessionOptions: false,
      activeSession: false,
      window: {
        width: 0,
      },
      text: JSON.parse(JSON.stringify(coreText)),
      languageLoading: false,
      languages: [{ name: "Español" }, { name: "English" }],
      selectedLanguage: "Español",
      userName: "",
    };
  },

  props: {
    parentCategory: { type: Object },
    snackbar: { type: Function },
    cartQuantity: { type: Number },
    updateShopingQuantity: { type: Function },
  },

  methods: {
    goHome: function () {
      this.$router.push("/");
    },

    login: function () {
      this.$router.push("/login");
    },

    register: function () {
      this.$router.push("/register");
    },

    isActiveSession: function () {
      var token, userId;
      token = localStorage.getItem("token");
      userId = localStorage.getItem("userId");
      this.userName = localStorage.getItem("name");
      this.activeSession = token !== null && userId !== null ? true : false;
    },

    closeSession: function () {
      events.$emit("closeSession");
      this.isActiveSession();
    },

    goCategories: function (item, subItem, PDI) {
      let route = PDI
        ? `/PDI/ ${item.name}/${subItem.name}?idCategory=${subItem.id}`
        : `/category/${item.name}/${subItem.name}?idCategory=${subItem.id}`;
      this.$router.push(route);
    },

    goToRisoul() {
      window.open("http://www.risoul.com.mx", "_blank");
    },

    goSucursales() {
      window.open("https://www.risoul.com.mx/sucursales/", "_blank");
    },

    goStore() {
      window.open("https://risoul.mercadoshops.com.mx/", "_blank");
    },

    setLanguage: function (language) {
      this.$emit("langHeaderSelection", this.selectedLanguage);

      switch (language) {
        case "Español":
          localStorage.setItem("isEnglish", false);
          events.$emit("language", false);
          break;
        case "English":
          localStorage.setItem("isEnglish", true);
          events.$emit("language", true);
          break;
      }
    },

    checkLangLocalStorage() {
      var getStrLang = localStorage.getItem("isEnglish");
      var langBool = getStrLang === "true";

      if (langBool) {
        this.selectedLanguage = "English";
        this.$emit("langHeaderSelection", this.selectedLanguage);
      }
    },

    updateQuantity: function () {
      this.updateShopingQuantity();
    },

    handleResize() {
      this.window.width = window.innerWidth;
    },
  },

  computed: {
    logoScreen: function () {
      if (this.window.width >= 960) {
        if (this.selectedLanguage !== "Español") {
          return "https://risoulimages.s3.us-west-2.amazonaws.com/logos/logo_blanco_rs_en.png";
        } else {
          return "https://risoulimages.s3.us-west-2.amazonaws.com/logos/logo_blanco_rs_es.png";
        }
      } else
        return "https://risoulimages.s3-us-west-2.amazonaws.com/logos/imago_blanco.webp";
    },

    headerItemsContainerClass: function () {
      if (this.window.width <= 960)
        return {
          headerItemsContainer: false,
          headerItemsContainerMovilsm: true,
        };
      else
        return {
          headerItemsContainer: true,
          headerItemsContainerMovilsm: false,
        };
    },

    quantityShopping: function () {
      return this.cartQuantity;
    },

    currentText: function () {
      if (this.selectedLanguage !== "Español") {
        return this.text.english;
      } else {
        return this.text.spanish;
      }
    },
  },

  watch: {},

  mounted() {
    this.isActiveSession();
    this.updateQuantity();
  },

  created: function () {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.checkLangLocalStorage();
  },

  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.header-container {
  height: 60px;
  background-color: #0d3a7e;
}

.image-container {
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.image-container img {
  padding: 5px;
  max-width: 100%;
  max-height: 100%;
}

.headerItemsContainer {
  height: 60px;
}

.hover {
  cursor: pointer;
}

.header-text {
  font-size: 12px;
  color: white !important;
  cursor: pointer;
  width: 100px;
}

.menu-text {
  font-size: 12px;
  color: white;
}

.headerItemsContainerMovilsm {
  height: 50px;
  padding: 0 !important;
}

.navigation-bar {
  min-width: 100%;
}

.navigation-bar .v-toolbar__content {
  padding: 0 !important;
}

.menu-text-parent {
  font-size: 14px;
  color: white;
}

.button-menu {
  color: white;
  cursor: pointer;
  font-weight: bold;
  font-family: "ProximaNova", sans-serif !important;
  text-transform: uppercase;
}

.button-menu:hover {
  color: #fd6c17;
}

.button-menu-ventas {
  color: white;
  cursor: pointer;
  font-weight: bold;
  font-family: "ProximaNova", sans-serif !important;
  text-transform: uppercase;
}

.button-menu-ventas:hover {
  color: #073c79;
}

.onlineStore {
  background-color: #fa6b17 !important;
}

.lang-select {
  width: 180px;
  transform: scale(0.8);
  transform-origin: left;
}

.list-element:hover {
  cursor: pointer;
  color: black !important;
}

.button-menu-movil {
  color: white;
  cursor: pointer;
  font-weight: bold;
  font-family: "ProximaNova", sans-serif !important;
  font-size: 10px !important;
  text-transform: uppercase;
}

.onlineStoreMovil {
  background-color: #fa6b17 !important;
  font-size: 10px !important;
}

/* CSS Sin Uso */
/* .quick-order-container {
  width: 32rem;
}
.add-order {
  color: white;
  width: 12rem;
}
.more-lines {
  color: white;
  width: 10rem;
}
.order-art {
  height: 20px !important;
  width: 8rem;
}
.order-cant {
  width: 4.5rem;
  margin-left: 5%;
  height: 20px !important;
}
.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  padding-bottom: 20px;
}

.colorHover {
  color: #fd6c17;
} */
</style>
